<core-generic-table
  [dataInput]="ports()"
  [endpoint]="endpoint"
  [listTitle]="'ports.title' | translate"
  [columns]="columns"
  [modalTabs]="modalFields()"
  [actions]="actions"
  [customActions]="customActions"
  [globalActions]="globalActions"
  [showFilter]="true"
  [showActiveFilters]="true"
  [customFilters]="customFilters()"
  [showSelection]="false"
  [showActions]="true"
  [showCreateButton]="true"
  [enablePagination]="true"
  [onApiError]="handleApiError"
  [modelFactory]="portsModelFactory"
  class="o-layout__section"
></core-generic-table>
